import React from 'react';
import './index.scss';
import { FormikErrors, FormikValues } from 'formik';
import RichText from '../../richtext';

interface RadioButtonProps {
    checked?: boolean;
    className?: string;
    disabled?: boolean;
    errors: string | string[] | FormikErrors<FormikValues> | FormikErrors<FormikValues>[];
    id: string;
    label?: string;
    name: string;
    onBlur: (e) => void;
    onChange: (e) => void;
    touched: boolean;
}

const RadioButton = (props: RadioButtonProps) => {
    const baseClassName = 'a-radiobutton';

    const handleChange = () => {
        const id = props.id;
        const name = props.name;
        props.onChange({ target: { name, value: id } });
        setTimeout(() => props.onBlur({ target: { name } }), 0);
    };

    return (
        <>
            <div className={`${baseClassName} ${props.className}`}>
                <input
                    checked={props.checked}
                    disabled={props.disabled}
                    id={props.id}
                    name={props.name}
                    type="radio"
                    onChange={handleChange}
                    value={props.id}
                />
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor={props.id} />
                <RichText className={`${baseClassName}__text light-text`} text={props.label} />
            </div>
            {props.errors && props.touched && <div className={`${baseClassName}__msg small-text`}>{props.errors}</div>}
        </>
    );
};

RadioButton.defaultProps = {
    checked: false,
    className: '',
    disabled: false,
    label: '',
};

export default RadioButton;
